import Vue from 'vue'
import Vuex from 'vuex'
// import apiclient from '@/apiclient.js'
// import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: 'Clicker-Alma Survey',
    busy: false,
    isSandbox: false
  },

  mutations: {
    
  },
  
  actions: {
    sleeper: function(context, payload) {
      let millis = (payload.millis) ? payload.millis : 100;
      return new Promise(function(resolve) { setTimeout(() => { return resolve(); }, millis); })
    }
  },
  
  getters: {
    isSandbox: function(state) { return state.isSandbox },
  }
})